import React from "react";
import { Link } from "react-router-dom";
import { Fuel, Users, Gauge } from "lucide-react";
import { formatINR } from "@/lib/api";
import SmartImage from "@/components/common/SmartImage";

export default function CarCard({ car, testId }) {
  return (
    <Link
      to={`/cars/${car.slug}`}
      data-testid={testId || `car-card-${car.slug}`}
      className="group card-premium overflow-hidden flex flex-col"
    >
      <div className="aspect-[16/10] overflow-hidden bg-[#F3F6FA]">
        <SmartImage
          src={car.image}
          alt={`${car.brand_name} ${car.model}`}
          label={`${car.brand_name} ${car.model}`}
          className="group-hover:scale-[1.05] transition-transform duration-700 ease-out"
        />
      </div>
      <div className="p-5 flex flex-col gap-2">
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{car.brand_name}</div>
        <div className="font-display text-xl tracking-tight">{car.model}</div>
        {car.tagline && <div className="text-sm text-muted-foreground line-clamp-1">{car.tagline}</div>}
        <div className="mt-2 flex items-center justify-between">
          <div className="font-mono text-sm">
            {formatINR(car.price_min)}{car.price_max > car.price_min ? ` – ${formatINR(car.price_max)}` : ""}
          </div>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            {car.specs?.seats && (<span className="inline-flex items-center gap-1"><Users className="w-3 h-3"/> {car.specs.seats}</span>)}
            <span className="inline-flex items-center gap-1"><Fuel className="w-3 h-3"/> {car.fuel_types?.[0]}</span>
            {car.specs?.mileage_kmpl && (<span className="inline-flex items-center gap-1"><Gauge className="w-3 h-3"/> {car.specs.mileage_kmpl}</span>)}
          </div>
        </div>
      </div>
    </Link>
  );
}
